<template>
	<v-dialog v-model="showPharmacistDialog" max-width="400" light>
		<template v-slot:activator="{ on: dialog }" v-if="icon">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn fab x-small depressed color="primary" v-on="{...dialog, ...tooltip}">
						<v-icon dark>mdi-plus</v-icon>
					</v-btn>
				</template>
				<span>Add Pharmacist</span>
			</v-tooltip>
		</template>
        
		<template v-slot:activator="{ on }" v-else>
			<v-btn color="primary" dark v-on="on">Add Pharmacist</v-btn>
		</template>

        <v-form ref="pharmacistForm" @submit.prevent="savePharmacist" class="custom-form">
            <v-card>
                <v-card-title>Pharmacist</v-card-title>

                <v-divider></v-divider>

                <v-cart-text>
                    <v-row no-gutters class="mb-1 pt-1">
                        <v-col cols="3" class="pl-2">Name</v-col>
                        <v-col cols="9" class="pr-5">
                            <v-text-field
                                dense
                                v-model="pharmacist.name"
                                outlined
                                hide-details
                                autocomplete="off"
                                :rules="[() => !!pharmacist.name || 'Enter pharmacist name']"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-1">
                        <v-col cols="3" class="pl-2">Shop Name</v-col>
                        <v-col cols="9" class="pr-5">
                            <v-text-field
                                dense
                                v-model="pharmacist.shop"
                                outlined
                                hide-details
                                autocomplete="off"
                                :rules="[() => !!pharmacist.name || 'Enter shop name']"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-1">
                        <v-col cols="3" class="pl-2">Phone</v-col>
                        <v-col cols="9" class="pr-5">
                            <v-text-field
                                dense
                                v-model="pharmacist.phone"
                                outlined
                                hide-details
                                autocomplete="off"
                                :rules="[() => !!pharmacist.name || 'Enter phone']"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3" class="pl-2">Address</v-col>
                        <v-col cols="9" class="pr-5">
                            <v-textarea
                                auto-grow
                                outlined
                                rows="1"
                                row-height="15"
                                hide-details
                                v-model="pharmacist.address"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-spacer></v-spacer>

                        <div class="pr-5 pt-1 pb-3">
                            <v-btn color="primary" dark type="submit" height="28" class="mr-1">Save</v-btn>
                            <v-btn color="error" dark @click="closePharmacistDialog" height="28">Close</v-btn>
                        </div>
                    </v-row>
                </v-cart-text>
            </v-card>
        </v-form>
	</v-dialog>
</template>

<script>
export default {
    data: () => ({
        pharmacist: {
			id: null,
            name: null,
            shop: null,
            phone: null,
            address: null,
		},
		showPharmacistDialog: false,
	}),

	props: {
		icon: false
	},

	methods: {
		closePharmacistDialog() {
			this.resetPharmacist();
			setTimeout(() => {
				this.showPharmacistDialog = false;
			}, 100);
		},

		async savePharmacist() {
            let isValid = true;
            this.$refs.pharmacistForm.validate();
            this.$refs.pharmacistForm.inputs.forEach(input => {
                if(input.hasError) isValid = false;
            })

            if(!isValid) {
                return;
            }
		
			let isSuccess = await this.$store.dispatch('pharmacist/savePharmacist', this.pharmacist);
			if(isSuccess) {
				if(this.pharmacist.id == null) {
					this.resetPharmacist();
				} else {
					this.closePharmacistDialog();
				}
			}
        },

		resetPharmacist() {
			this.$refs.pharmacistForm.reset();
			Object.keys(this.pharmacist).forEach(key => {
				this.pharmacist[key] = null;
            })
            this.$refs.pharmacistForm.resetValidation();
		}
	}
};
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
    height: 26px;
    width: 29px;
}
</style>